<template>
  <div class="app-container">
    <div style="margin-bottom: 10px">
      <el-button
        size="medium"
        type="success"
        @click="examine('batch')"
        style="margin-bottom: 5px"
        v-if="roles.includes('/company/batch_examine')"
        :disabled="multipleSelection.length == 0"
        >批量审批</el-button
      >
    </div>
    <!-- <el-select
      filterable
      v-if="userInfo.is_super == 1"
      class="screenInput"
      v-model="screen.park_id"
      placeholder="请选择园区"
      @change="screenPark"
    >
      <el-option label="全部" value=""></el-option>
      <el-option
        :label="item.name"
        :value="item.id"
        v-for="(item, index) in parkList"
        :key="index"
      ></el-option>
    </el-select> -->
    <el-select
      filterable
      class="screenInput"
      v-model="screen.company_id"
      placeholder="请选择企业名称"
      v-if="userInfo.type != 2"
    >
      <el-option label="全部" value=""></el-option>
      <el-option
        :label="item1.name"
        :value="item1.id"
        v-for="(item1, index1) in ScreencompanyList"
        :key="index1"
      ></el-option>
    </el-select>
    <el-input
      maxlength="11"
      class="screenInput"
      v-model="screen.like"
      placeholder="员工名称或者手机号"
    ></el-input>
    <el-select
      filterable
      class="screenInput"
      v-model="screen.status"
      placeholder="请选择状态"
    >
      <el-option
        :label="item.name"
        :value="item.id"
        v-for="(item, index) in statusList"
        :key="index"
      ></el-option>
    </el-select>
    <el-button type="primary" @click="(screen.page = 1), fetchData()"
      >筛选</el-button
    >
    <el-button type="primary" plain @click="chongZhi()">重置</el-button>

    <el-table
      max-height="700"
      v-loading="listLoading"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column type="selection" width="55" :selectable="selectable"> </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="用户姓名">
        <template slot-scope="scope">
          {{ scope.row.username }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="头像" align="center">
        <template slot-scope="scope">
          <img
            v-if="scope.row.avatar_url"
            class="tableIcon"
            alt=""
            srcset=""
            :src="imageOss + scope.row.avatar_url"
          />
        </template>
      </el-table-column> -->
      <el-table-column label="联系电话" align="center">
        <template slot-scope="scope">
          {{ scope.row.phone }}
        </template>
      </el-table-column>
      <el-table-column label="园区名称" align="center">
        <template slot-scope="scope">
          <div class="line2" v-if="scope.row.park">
            {{ scope.row.park.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="企业名称" align="center">
        <template slot-scope="scope">
          <div class="line2" v-if="scope.row.company">
            {{ scope.row.company.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="性别" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.sex">
            {{ scope.row.sex == 1 ? "男" : scope.row.sex == 2 ? "女" : "保密" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="学历" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.education == 1"> 其他 </span>
          <span v-if="scope.row.education == 2"> 小学 </span>
          <span v-if="scope.row.education == 3"> 初中 </span>
          <span v-if="scope.row.education == 4"> 高中 </span>
          <span v-if="scope.row.education == 5"> 专科 </span>
          <span v-if="scope.row.education == 6"> 本科 </span>
          <span v-if="scope.row.education == 7"> 研究生 </span>
        </template>
      </el-table-column>

      <el-table-column label="状态" width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="
              scope.row.status == '2'
                ? 'success'
                : scope.row.status == '1'
                ? 'info'
                : 'danger'
            "
            disable-transitions
            >{{
              scope.row.status == 2
                ? "已通过"
                : scope.row.status == 1
                ? "已申请"
                : "已驳回"
            }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at"
        label="操作"
        width="250"
        fixed="right"
      >
        <template slot-scope="scope">
          <!-- <el-button
            v-if="roles.includes('/company_user/info')"
            size="mini"
            type="warning"
            @click="handleSee(scope.row)"
            >查看</el-button
          >
          <el-button
            v-if="roles.includes('/company_user/edit')"
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            >编辑</el-button
          > -->
            <!-- -->
          <el-button
            size="mini"
            type="success"
          v-if="
              roles.includes('/company/user_apply_examine') &&
              scope.row.status == 1
            " 
            @click="examine('single', scope.row)"
            >审批</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-dialog title="审批" :visible.sync="dialogVisible" width="500px">
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-form-item
          label="审批"
          prop="status"
          :rules="[
            { required: true, message: '请选择审批', trigger: 'change' },
          ]"
        >
          <el-radio-group v-model="form.status">
            <el-radio :label="2">通过</el-radio>
            <el-radio :label="3">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          prop="system_role_id"
          label="选择角色"
          v-if="form.status == 2"
        >
          <el-select v-model="form.system_role_id" placeholder="请选择">
            <el-option
              v-for="item in roleList"
              :key="item.value"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="reason" label="驳回原因" v-if="form.status == 3">
          <el-input type="textarea" v-model="form.reason"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('form')"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  user_apply_list,
  openPark,
  openRole,
  openCompany,
  user_apply_examine,
  user_apply_batch_examine
} from "@/api/index";
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";
export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageOss"]),
  },
  data() {
    return {
      multipleSelection: [],
      dialogVisible: false,
      token: getToken(),
      statusList: [
        {
          name: "已申请",
          id: 1,
        },
        {
          name: "已通过",
          id: 2,
        },
        {
          name: "已驳回",
          id: 3,
        },
      ],
      total: 0,
      list: [],
      listLoading: true,
      token: getToken(),
      screen: {
        page: 1,
        page_size: 15,
        like: "",
        company_id: "",
        park_id: "",
        status: "",
      },
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      roleList: [],
      companyList: [],
      ScreencompanyList: [],
      form: {},
      rules: {
        system_role_id: [
          { required: true, message: "请选择角色", trigger: "change" },
        ],
        status: [{ required: true, message: "请选择审核", trigger: "change" }],
        reason: [
          { required: true, message: "请输入驳回意见", trigger: "blur" },
        ],
      },
      companyIds: [],
      examineType:''
    };
  },
  created() {
    if (this.userInfo.is_super != 1) {
      if (this.userInfo.type == 1) {
        this.screen.park_id = this.userInfo.park_id;
        this.screenPark(this.userInfo.park_id);
      } else if (this.userInfo.type == 2) {
        this.screen.park_id = this.userInfo.park_id;
        this.screen.company_id = this.userInfo.company_id;
        this.companyIds.push(this.userInfo.company_id);
        this.ScreencompanyList = [{ ...this.userInfo.company }];
      }
    }
    this.getCompany("screen");
    this.getPark();
    this.fetchData();
  },
  methods: {
    selectable(row, index) {
      if (row.status == 1) {
        return true;
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
              });
              if(that.examineType == 'single'){
user_apply_examine(that.form).then((res) => {
                loading.close();
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.dialogVisible = false;
                  that.fetchData();
                }
              });
              }else{
                user_apply_batch_examine(that.form).then((res) => {
                loading.close();
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.dialogVisible = false;
                  that.fetchData();
                }
              });
              }


              
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });
          return false;
        }
      });
    },
    // 审批
    examine(type,val) {
      this.examineType = type
      if(type == 'single'){
        this.form = {
        id: val.id,
        status: "",
        system_role_id: "",
        reason: "",
      };
      this.getRole(val.company.type,false);
      this.dialogVisible = true;
      }else{
        var ids = [];
         if (this.multipleSelection.length) {
          this.multipleSelection.forEach((item, index) => {
            ids.push(item.id);
          });
        } else {
          this.$message.error("至少选择一个用户");
          return;
        }
this.form = {
        id: ids.toString(","),
        status: "",
        system_role_id: "",
        reason: "",
      };


          this.getRole('1,2',true);
          this.dialogVisible = true;
      }
      
      
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    chongZhi() {
      this.screen = {
        page: 1,
        page_size: 15,
        like: "",
        company_id: "",
        park_id: "",
        status: "",
      };
      if (this.userInfo.is_super != 1) {
        if (this.userInfo.type == 1) {
          this.screen.park_id = this.userInfo.park_id;
          this.screenPark(this.userInfo.park_id);
        } else if (this.userInfo.type == 2) {
          this.screen.park_id = this.userInfo.park_id;
          this.screen.company_id = this.userInfo.company_id;
          this.ScreencompanyList = [{ ...this.userInfo.company }];
        }
      }
      // if (this.userInfo.park_id !== 0) {
      //   this.screen.park_id = this.userInfo.park_id;
      // } else {
      //   this.screen.park_id = "";
      // }
      // if (this.userInfo.company_id !== 0) {
      //   this.screen.company_id = this.userInfo.company_id;
      // } else {
      //   this.screen.company_id = "";
      // }
      this.fetchData();
    },
    screenPark(e) {
      this.screen.company_id = "";
      this.getCompany("screen", e);
    },
    // 获取企业
    getCompany(type, id, index) {
      var data = {
        park_id: this.$store.state.mainParkId,
        is_page: 2,
      };
      openCompany(data).then((response) => {
        if (type == "screen") {
          this.ScreencompanyList = response.data.lists;
        } else {
          if (type == "add") {
            this.$set(this.companyList, index, response.data.lists);
          }
        }
      });
    },
    // 获取角色
    getRole(type,isBatch) {
      const data = {
        is_page: 2,
        is_tree: 1,
        role_type: 2,
        type: isBatch ? type : type == 1 ? 2 : 1,
        company_id: 0,
        park_id: this.$store.state.mainParkId,
      };
      openRole(data).then((res) => {
        this.roleList = res.data.lists;
        // this.$set(this.roleList, index, res.data.lists);
      });
    },
    // 获取园区
    getPark() {
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    fetchData() {
      this.listLoading = true;
      user_apply_list(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploader {
  width: 60px;
  height: 60px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 70px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.screenInput {
  width: 200px;
  margin-right: 10px;
  margin-bottom: 5px;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.upload-demo {
  ::v-deep .el-upload {
    width: 100%;
    .el-upload-dragger {
      width: 100%;
    }
  }
}
.error {
  width: 100%;
  max-height: 100px;
  overflow: auto;
  padding: 10px;
  border: 1px solid;
  color: red;
  div {
    line-height: 20px;
  }
}
</style>
